import { updateCallIsSummaryHelpfulDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateCallIsSummaryHelpfulCallable = getCallable(
  updateCallIsSummaryHelpfulDefinition,
);
